import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const Envelope: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.JSX.Element => {
  const normal = (
    <path d="M41.072 34.99l-11.5-11.552 11.5-10.287v21.84zm-33.478.831l11.46-11.512 4.772 4.268 4.775-4.27L40.065 35.82H7.594zm-.666-22.36l11.156 9.98L6.928 34.647V13.461zm33.28-1.282L23.826 26.833 7.445 12.18h32.763zM5.628 37.121h36.744V10.88H5.628v26.242z" />
  );

  const normalHover = (
    <path d="M16.931 14.403H31.07v-1H16.931v1zm0 4.372H31.07v-1H16.931v1zM41.072 34.99L29.571 23.438l11.501-10.287V34.99zm-33.478.831l11.461-11.512 4.771 4.268 4.775-4.271 11.463 11.515H7.594zm-.666-22.36l11.156 9.98L6.928 34.647V13.461zm2.754-1.282v2.001l-2.237-2.001h2.237zm1.3-4.416h26.036v7.27l-13.192 11.8-12.844-11.49v-7.58zm27.336 4.416h1.89l-1.89 1.69v-1.69zm0-1.3V6.462H9.682v4.417H5.628v26.242h36.744V10.879h-4.054z" />
  );

  const xSmall = (
    <path d="M40.958 34.904L29.413 23.305l11.545-10.327v21.926zm-33.54.804l11.505-11.556 4.772 4.27 4.775-4.273 11.507 11.56H7.417zm-.64-22.42L17.978 23.31 6.777 34.56V13.288zm33.347-1.259l-16.43 14.697-16.43-14.697h32.86zM5.515 36.971h36.707V10.766H5.514V36.97z" />
  );

  const xSmallHover = (
    <path d="M40.959 34.904L29.412 23.305 40.96 12.978v21.926zm-33.54.804l11.503-11.556 4.773 4.27 4.775-4.273 11.507 11.56H7.418zm-.641-22.42L17.98 23.31 6.778 34.56V13.288zm2.79-1.259v2.06l-2.303-2.06h2.303zm1.263-4.416h26.074v7.296l-13.21 11.817L10.831 15.22V7.613zM38.17 12.03h1.956l-1.956 1.75v-1.75zm0-1.263V6.35h-28.6v4.416H5.514V36.97h36.707V10.766H38.17z" />
  );

  return getIcon({ size, isHovered, normal, normalHover, xSmall, xSmallHover });
};

export default Envelope;
